import { useAuthStore } from './auth-store';

/**
 * usePermission — permission-check helper.
 *
 * Super Admins pass all checks. Otherwise the effective permissions set
 * from /api/auth/me is consulted.
 *
 * Usage:
 *   const { has, isSuperAdmin } = usePermission();
 *   if (has(MASTERS_EDIT)) { ... }
 */
export function usePermission() {
  const isSuperAdmin = useAuthStore((s) => s.user?.isSuperAdmin ?? false);
  const permissions = useAuthStore((s) => s.permissions);

  return {
    isSuperAdmin,
    has(key: string): boolean {
      return isSuperAdmin || permissions.has(key);
    },
    hasAny(...keys: string[]): boolean {
      if (isSuperAdmin) return true;
      return keys.some((k) => permissions.has(k));
    },
    hasAll(...keys: string[]): boolean {
      if (isSuperAdmin) return true;
      return keys.every((k) => permissions.has(k));
    },
  };
}
